"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.placementTestResultSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const proficiencyLevel_1 = require("./proficiencyLevel");
exports.placementTestResultSchema = zod_1.default.object({
    proficiencyLevel: proficiencyLevel_1.proficiencyLevelSchema,
    grammar: zod_1.default.number().nullable(),
    pronunciation: zod_1.default.number().nullable(),
    vocabulary: zod_1.default.number().nullable(),
    comprehension: zod_1.default.number().nullable(),
    naturalness: zod_1.default.number().nullable(),
});
//# sourceMappingURL=placementTest.js.map